import { render, staticRenderFns } from "./ManagerIndex.vue?vue&type=template&id=519de072&"
import script from "./ManagerIndex.vue?vue&type=script&lang=js&"
export * from "./ManagerIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports